import { ImageObject, ImageObjectSchema } from './imageObject'
import {
  defineCborSchema,
  CborField,
  type CborSchema,
} from '@mesh/friendly-cbor-serializer'
import type { Id } from '../aliases'

export type Profile = {
  id?: Id
  friendlyName: string
  avatar?: ImageObject
  firstName?: string
  lastName?: string
  primaryEmail?: string
}

export const ProfileSchema: CborSchema<Profile> = defineCborSchema<Profile>({
  id: CborField({ key: 0, required: false }),
  friendlyName: CborField({ key: 1 }),
  avatar: CborField({ key: 3, required: false, type: ImageObjectSchema }),
  primaryEmail: CborField({ key: 5, required: false }),
  firstName: CborField({ key: 7, required: false }),
  lastName: CborField({ key: 8, required: false }),
})
